/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  useEffect, useState, useCallback, useRef,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import moment from 'moment';
import {
  Paper, Avatar, Container, Button, Drawer, Table, TableBody, TableCell, TableFooter, TablePagination, TableRow, Typography, Chip,
} from '@mui/material';
import FilterList from '@mui/icons-material/FilterList';
import * as actions from '../../store/actions';
import Spinner from '../../components/Spinner/index';
import { i18n } from '../../translate/i18n';
import EnhancedTableHead from '../../UI/MaterialTableOverrides/EnhancedTableHead';
import TablePaginationActionsWrapped from '../../UI/MaterialTableOverrides/TablePaginationActions';
import TableTitle from '../../UI/MaterialTableOverrides/TableTitle';
import statusLabel from '../../utils/statusLabel';
import { formatLanguageFromLocalStorage } from '../../utils/formatLanguageFromLocalStorage';
import statusLabelMaintenance from '../../utils/statusLabelMaintenance';
import numberToCurrency from '../../utils/numberToCurrency';

import ModalFilter from '../../containers/Maintenances/ModalFilter/index';

export default function TableMaintenances(props) {
  const dispatch = useDispatch();
  const textInput = useRef(null);

  const [firstLoad, setFirstLoad] = useState(true);
  const [page, setPage] = useState(1);
  const [alreadySerched, setAlreadySerched] = useState(false);
  const [limit, setLimit] = useState(5);
  const [searchText, setSearchText] = useState('');
  const [orderBy, setOrderBy] = useState('createdAt');
  const [order, setOrder] = useState('asc');
  const [exportLoading, setExportLoading] = useState(false);

  const selectedSites = useSelector(state => state.sites.selectedSitesPlaces);

  // Modal Filter
  const filteredEquipments = useSelector(state => state.maintenances.filteredEquipments);
  const filteredPlaces = useSelector(state => state.maintenances.filteredPlaces);
  const filteredAreas = useSelector(state => state.actions.filteredAreas);
  const filteredStatus = useSelector(state => state.maintenances.filteredStatus);
  const filteredCreatedAt = useSelector(state => state.maintenances.createdAt);
  const filteredSendToMaintenanceDate = useSelector(state => state.maintenances.sendToMaintenanceDate);
  const filteredReturnFromMaintenanceDate = useSelector(state => state.maintenances.returnFromMaintenanceDate);
  const filteredWarranty = useSelector(state => state.maintenances.warranty);
  const filteredExpiration = useSelector(state => state.maintenances.expiration);

  const localStorageLang = localStorage.getItem("i18nextLng");
  const emailLanguage = formatLanguageFromLocalStorage(localStorageLang);

  const fetchMaintenancesExport = useCallback(() => dispatch(actions.fetchMaintenancesExport(searchText, order, orderBy, selectedSites, filteredEquipments, filteredCreatedAt, filteredSendToMaintenanceDate, filteredReturnFromMaintenanceDate, filteredWarranty, filteredExpiration, filteredPlaces, filteredStatus, emailLanguage)), [searchText, order, orderBy, selectedSites, filteredEquipments, filteredCreatedAt, filteredSendToMaintenanceDate, filteredReturnFromMaintenanceDate, filteredWarranty, filteredExpiration, filteredPlaces, filteredStatus, emailLanguage])

  const fetchMaintenances = useCallback(
    () => dispatch(actions.fetchMaintenancesByEquipment(page, limit, searchText, order, orderBy,false, null, selectedSites, filteredEquipments, filteredCreatedAt, filteredSendToMaintenanceDate, filteredReturnFromMaintenanceDate, filteredWarranty, filteredExpiration, filteredPlaces, filteredStatus /* selectedSites, filteredPlaces, filteredStatus, filteredAreas, filteredSendToMaintenanceDate, filteredEquipments */)),
    [page, limit, searchText, order, orderBy,false, null, selectedSites, filteredEquipments, filteredCreatedAt, filteredSendToMaintenanceDate, filteredReturnFromMaintenanceDate, filteredWarranty, filteredExpiration, filteredPlaces, filteredStatus /* selectedSites, filteredPlaces, filteredStatus, filteredAreas, filteredEquipments, filteredSendToMaintenanceDate */],
  );

  const maintenances = useSelector(state => state.maintenances.maintenances);
  const maintenancesFilter = useSelector(state => state.maintenances.maintenancesFilter);
  const timelineMaintenancesLoading = useSelector(state => state.maintenances.timelineMaintenancesLoading);
  const [isFilterOpen, setIsFilterOpen] = useState(false);


  const headRows = [
    {
      id: '_id', numeric: false, disablePadding: false, label: i18n.t('headRowsTableMaintenances.id'),
    },
    {
      id: 'equipment.equipmentModel.name', numeric: false, disablePadding: false, label: i18n.t('headRowsTableMaintenances.equipment'),
    },
    {
      id: 'createdAt', numeric: false, disablePadding: false, label: i18n.t('headRowsTableMaintenances.createdAt'),
    },
    {
      id: 'sendToMaintenanceDate', numeric: false, disablePadding: false, label: i18n.t('headRowsTableMaintenances.sendToMaintenanceDate'),
    },
    {
      id: 'returnFromMaintenanceDate', numeric: false, disablePadding: false, label: i18n.t('headRowsTableMaintenances.returnFromMaintenanceDate'),
    },
    {
      id: 'warranty', numeric: false, disablePadding: false, label: i18n.t('headRowsTableMaintenances.warrantyDate'),
    },
    {
      id: 'expiration', numeric: false, disablePadding: false, label: i18n.t('headRowsTableMaintenances.expirationDate'),
    },
    {
      id: 'equipment.place.name', numeric: false, disablePadding: false, label: i18n.t('headRowsTableMaintenances.place'),
    },
    {
      id: 'value', numeric: false, disablePadding: false, label: i18n.t('headRowsTableMaintenances.amount'),
    },
    {
      id: 'status', numeric: false, disablePadding: false, label: i18n.t('headRowsTableMaintenances.status'),
    },
  ];

  useEffect(() => {
    if (!isEmpty(maintenancesFilter)) {
      setPage(maintenancesFilter.page);
      setLimit(maintenancesFilter.limit);
      setSearchText(maintenancesFilter.searchText);
      setOrderBy(maintenancesFilter.orderBy);
      setOrder(maintenancesFilter.order);
    }
    setFirstLoad(false);
    dispatch(actions.setOpenDrawer(true))
  }, []);

  useEffect(() => {
    return () => {
      dispatch(actions.setMaintenancesFilter(page, limit, searchText, order, orderBy));
    }
  }, [page, limit, order, orderBy, searchText]);

  useEffect(() => {
    if (!firstLoad) {
      fetchMaintenances();
      setAlreadySerched(true);
    }
  }, [firstLoad, page, limit, order, orderBy]);

  useEffect(() => {
    if (!firstLoad) {
      setPage(1);
      fetchMaintenances();
      setAlreadySerched(true);
    }
  }, [filteredEquipments, filteredCreatedAt, filteredSendToMaintenanceDate, filteredReturnFromMaintenanceDate, filteredWarranty, filteredExpiration, filteredPlaces, selectedSites, filteredStatus /* filteredPlaces, selectedSites, filteredEquipments, filteredStatus, filteredAreas, filteredSendToMaintenanceDate */]);

  useEffect(() => {
    if (searchText !== '' || alreadySerched) {
      const timer = setTimeout(() => {
        if (searchText === textInput.current.value) {
          fetchMaintenances();
        }
      }, 500);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [searchText, textInput]);

  const handleChangePage = (e, page) => {
    setPage(page + 1);
  };

  const handleChangeRowsPerPage = (e) => {
    setLimit(e.target.value);
    setPage(1);
  };

  const handleRequestSort = (event, property) => {
    const isDesc = orderBy === property && order === 'desc';
    setOrder(isDesc ? 'asc' : 'desc');
    setOrderBy(property);
  };

  const selectRow = (e, id, equipId) => {
    props.history.push(`form-maintenance/${id}/${equipId}`);
  };

  const styles = {
    table: {
      position: 'relative',
      marginBottom: 50,
    },
    tableRow: {
      cursor: 'pointer',
    },
    opacityContainer: {
      opacity: timelineMaintenancesLoading ? '0.3' : '1',
    },
    spinner: {
      position: 'absolute',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: '100%',
      top: '-5px',
      opacity: '1',
      zIndex: 2,
    },
    noResults: {
      height: '100px',
    },
    deleteTextConfirm: {
      marginLeft: '-30px',
      fontWeight: 'bold',
    },
    editWidth: {
      width: '90%',
    },
    avatarContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    thumbUp: {
      color: '#349c34',
    },
    thumbDown: {
      color: '#d04545',
    },
    avatar: {
      width: '2.75rem',
      height: '2.75rem',
    },
    avatarSmallText: {
      fontSize: '0.75rem',
      width: '2.75rem',
      height: '2.75rem',
    },
    chip: {
      margin: 5,
      color: 'white',
      // border: '1px solid grey'
    },
    cell: {
      fontSize: '0.775rem',
      padding: '0.25rem',
      paddingLeft: '1.3rem',
    },
    cellPhotoContainer: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: '0.5rem',
    },
    buttonFilterContainer: {
      display: 'flex',
      flexDirection: 'row',
      padding: '0px 20px 10px 20px',
    },
    buttonFilterIcon: {
      marginLeft: 5,
    },
    buttonFilter: {
      zIndex: 200,
      backgroundColor: 'green',
      height: '2.2rem',
      width: '6.5rem',
      padding: '1rem',
      color: '#fff',
    },
    clearFilter: {
      cursor: 'pointer',
      textDecoration: 'underline',
      zIndex: 200,
      padding: '0.75rem 0.5rem',
      color: '#000',
    },
    filterContainer: {
      position: 'relative',
      width: '100%',
    },
    filterChipContainer: {
      paddingLeft: 20,
      display: 'flex',
      flexWrap: 'wrap',
    },
    filterChip: {
      cursor: 'pointer',
      margin: 5,
    },
  };

  const deleteFilteredSite = (site) => {
    dispatch(actions.deleteFilteredSite(site));
  };

  const deleteFilteredUser = (user) => {
    dispatch(actions.filterActionUsersRemove(user));
  };

  const deleteFilteredEquipment = (equipment) => {
    dispatch(actions.filterMaintenanceEquipmentsRemove(equipment));
  };

  const deleteFilteredPlaces = (place) => {
    dispatch(actions.filterMaintenancePlacesRemove(place))
  }

  const deleteFilteredArea = (area) => {
    dispatch(actions.filterActionAreasRemove(area));
  };

  const deleteFilteredStatus = (status) => {
    dispatch(actions.filterMaintenanceStatusRemove(status));
  };

  const deleteFilteredCreatedAt = () => {
    dispatch(actions.filterMaintenanceCreatedAtRemove());
  };

  const deleteFilteredSendToMaintenanceDate = () => {
    dispatch(actions.filterMaintenanceSendToMaintenanceDateRemove());
  };

  const deleteFilteredReturnFromMaintenanceDate = () => {
    dispatch(actions.filterMaintenanceReturnFromMaintenanceDateRemove());
  };

  const deleteFilteredWarranty = () => {
    dispatch(actions.filterMaintenanceWarrantyRemove());
  };

  const deleteFilteredExpiration = () => {
    dispatch(actions.filterMaintenanceExpirationRemove());
  };

  const clearFilterButton = () => {
    if ((filteredEquipments && filteredEquipments.length > 0)
      || (filteredPlaces && filteredPlaces.length > 0)
      || (filteredAreas && filteredAreas.length > 0)
      || (filteredStatus && filteredStatus.length > 0)
      || (filteredCreatedAt)
      || (filteredSendToMaintenanceDate)
      || (filteredReturnFromMaintenanceDate)
      || (filteredWarranty)
      || (filteredExpiration)) return <Typography onClick={handleClickClearFilters} style={styles.clearFilter}>{i18n.t('typographyTablesActions.clearFilter')}</Typography>;
  };

  const renderSitesChips = () => (selectedSites && selectedSites.map(site => (<Chip
    key={site._id}
    label={site.name}
    onDelete={() => deleteFilteredSite(site)}
    style={styles.filterChip} />)));
  const renderEquipmentsChips = () => (filteredEquipments && filteredEquipments.map(equipment => (<Chip
    key={equipment.value}
    label={equipment.label}
    onDelete={() => deleteFilteredEquipment(equipment)}
    style={styles.filterChip} />)));
  const renderPlacesChips = () => (filteredPlaces && filteredPlaces.map((place) => (<Chip
    key={place.value}
    label={place.label}
    onDelete={() => deleteFilteredPlaces(place)}
    style={styles.filterChip} />)))
  const renderAreasChips = () => (filteredAreas && filteredAreas.map(area => (<Chip
    key={area.value}
    label={area.label}
    onDelete={() => deleteFilteredArea(area)}
    style={styles.filterChip} />)));
  const renderStatusChips = () => (filteredStatus && filteredStatus.map(status => (<Chip
    key={status.value}
    label={status.label}
    onDelete={() => deleteFilteredStatus(status)}
    style={styles.filterChip} />)));
  const renderCreatedAtChip = () => (filteredCreatedAt && <Chip
    label={`${i18n.t('autocompleteMaintenanceModalFilter.createdAt')}: ${moment(filteredCreatedAt).format('DD/MM/YYYY')}`}
    onDelete={() => deleteFilteredCreatedAt()}
    style={styles.filterChip} />);
  const renderSendToMaintenanceDateChip = () => (filteredSendToMaintenanceDate && <Chip
    label={`${i18n.t('autocompleteMaintenanceModalFilter.sendToMaintenanceDate')}: ${moment(filteredSendToMaintenanceDate).format('DD/MM/YYYY')}`}
    onDelete={() => deleteFilteredSendToMaintenanceDate()}
    style={styles.filterChip} />);
  const renderReturnFromMaintenanceDateChip = () => (filteredReturnFromMaintenanceDate && <Chip
    label={`${i18n.t('autocompleteMaintenanceModalFilter.returnFromMaintenanceDate')}: ${moment(filteredReturnFromMaintenanceDate).format('DD/MM/YYYY')}`}
    onDelete={() => deleteFilteredReturnFromMaintenanceDate()}
    style={styles.filterChip} />);
  const renderWarrantyChip = () => (filteredWarranty && <Chip
    label={`${i18n.t('autocompleteMaintenanceModalFilter.warranty')}: ${moment(filteredWarranty).format('DD/MM/YYYY')}`}
    onDelete={() => deleteFilteredWarranty()}
    style={styles.filterChip} />);
  const renderExpirationChip = () => (filteredExpiration && <Chip
    label={`${i18n.t('autocompleteMaintenanceModalFilter.expiration')}: ${moment(filteredExpiration).format('DD/MM/YYYY')}`}
    onDelete={() => deleteFilteredExpiration()}
    style={styles.filterChip} />);

  const handleClickClearFilters = useCallback(() => dispatch(actions.filterMaintenanceClear()));

  const exportExcel = () => {
    setExportLoading(true);
    fetchMaintenancesExport().then(response => {
      if (response) {
        window.open(response.url, "_blank")
      }
      setExportLoading(false);
    })
  }

  function currencyFormat(num) {
    return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  }

  return <>
    <Drawer
      variant="temporary"
      anchor="right"
      onClose={() => setIsFilterOpen(false)}
      open={isFilterOpen}
    >
      <ModalFilter
        closeModal={() => setIsFilterOpen(false)}
      />
    </Drawer>
    <Container maxWidth="xl">
      <Paper>
        <div style={styles.filterContainer}>
          <TableTitle
            title={i18n.t('tableTitleTableMaintenances.title')}
            placeholder={i18n.t('tableTitleTableMaintenances.placeholder')}
            inputRef={textInput}
            value={searchText}
            onChange={(event) => {
              setPage(1);
              setSearchText(event.target.value);
            }}
            clickExport={exportExcel}
            downloading={exportLoading}
            exportButtonDisabled={timelineMaintenancesLoading}
            filter={false}
          />
        </div>
        <div style={styles.filterChipContainer}>
          <Button
            variant="contained"
            onClick={() => setIsFilterOpen(true)}
            style={styles.buttonFilter}>
            {i18n.t('buttonTableActions.text')}
              {' '}
            <FilterList style={styles.buttonFilterIcon} />
          </Button>
          {renderSitesChips()}
          {renderEquipmentsChips()}
          {renderPlacesChips()}
          {renderAreasChips()}
          {renderStatusChips()}
          {renderCreatedAtChip()}
          {renderSendToMaintenanceDateChip()}
          {renderReturnFromMaintenanceDateChip()}
          {renderWarrantyChip()}
          {renderExpirationChip()}
          {clearFilterButton()}
        </div>
        <Table style={styles.table}>
          <tbody>
            <tr>
              <td>
                {timelineMaintenancesLoading
                  && (
                    <div style={styles.spinner}>
                      <Spinner />
                    </div>
                  )}
                {maintenances.rows.length === 0
                  && (
                    <div style={styles.noResults}>
                      {!timelineMaintenancesLoading && <Typography style={styles.spinner}>{i18n.t('typographyTablesActions.noResults')}</Typography>}
                    </div>
                  )}
              </td>
            </tr>
          </tbody>
          <EnhancedTableHead
            style={styles.opacityContainer}
            headRows={headRows}
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
          />
          <TableBody style={styles.opacityContainer}>
            {maintenances.rows.map((col, index) => (
              <TableRow
                style={styles.tableRow}
                key={col._id}
                hover
                onClick={event => selectRow(event, col._id, col.equipment._id)}
              >
                <TableCell style={{
                  ...styles.cell,
                  fontWeight: 'bold',
                  textTransform: 'uppercase',
                  paddingLeft: '1rem',
                  width: '1.5rem'
                }}>{col.identifier ? col.identifier : '-'}</TableCell>

                <TableCell style={styles.cell}>
                  <div>{col.equipment.equipmentModel.name}</div>
                  <div style={{ color: 'grey' }}>{col.equipment.serialNumber}</div>
                </TableCell>
                <TableCell style={styles.cell}>{moment(col.createdAt).format('DD/MM/YYYY')}</TableCell>
                <TableCell style={styles.cell}>{col.sendToMaintenanceDate ? moment(col.sendToMaintenanceDate).format('DD/MM/YYYY') : '-'}</TableCell>
                <TableCell style={styles.cell}>{col.returnFromMaintenanceDate ? moment(col.returnFromMaintenanceDate).format('DD/MM/YYYY') : '-'}</TableCell>
                <TableCell style={styles.cell}>{col.warranty ? moment(col.warranty).format('DD/MM/YYYY') : '-'}</TableCell>
                <TableCell style={styles.cell}>{col.expiration ? moment(col.expiration).format('DD/MM/YYYY') : '-'}</TableCell>
                <TableCell style={styles.cell}>{col?.equipment?.place?.name}</TableCell>
                <TableCell style={styles.cell}>{col.value ? 'R$ ' + numberToCurrency(col.value) : '-'}</TableCell>
                <TableCell style={styles.cell}>
                  <Chip
                    label={statusLabelMaintenance(col.status, col).title}
                    style={{ backgroundColor: statusLabelMaintenance(col.status, col).color, ...styles.chip }}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
          <TableFooter style={styles.opacityContainer}>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                labelRowsPerPage={i18n.t('tableTitleTableMaintenances.rowsPerPage')}
                count={maintenances.count}
                rowsPerPage={parseInt(limit)}
                page={page - 1}
                SelectProps={{
                  native: true,
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActionsWrapped}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </Paper>
    </Container>
  </>;
}
